import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useMixpanel from '@/hooks/useMixpanel';
import t from '@/utils/Language/ResourceCard-translations';

const SuggestEditPanel = ({ resource, additionalClass, project }) => {
  let event;
  if (project === 'allhome') {
    event = 'Stay_Housed_Bay_Area';
  } else if (project === 'familyResourceFinder') {
    event = 'MSI_Family_Resource_Finder';
  } else {
    event = 'Mystery_Tracking';
  }

  const { track } = useMixpanel(event);

  const trackSuggestEdits = () => {
    const trackingObj = {
      opportunity_id: resource.id,
      opportunity_title: resource.title,
      organization_id: resource.organization.id,
      organization_slug: resource.organization.slug,
      project: project
    };

    track('Suggested edits', trackingObj);
  };

  return (
    <>
      <p className={additionalClass?.editSuggestContainer}>
        {t('See incorrect information for this resource?')}&nbsp;&nbsp;
        <a
          href={`/${resource.resource_type == 'Opportunity' ? 'opp' : 'org'}/${resource.slug}?showEditResourceModal=true`}
          rel="noreferrer"
          target="_blank"
          onClick={() => trackSuggestEdits()}
          className={additionalClass?.editSuggestLink}
        >
          <FontAwesomeIcon icon={[`fas`, `edit`]} className={additionalClass?.tagIcon} />
          {t('Suggest edits')}
        </a>
      </p>
    </>
  );
};

export default SuggestEditPanel;
